"use client"

import {
  Card,
  CardContent,
  Typography,
  Stack,
  Box,
  IconButton,
  Button,
} from "@mui/material"
import { CalendarDays, Clock, MapPin, ArrowRight } from "lucide-react"
import { NavLink } from "react-router-dom"

const events = [
  {
    id: 1,
    title: "Property Inspection: 123 Main St",
    date: "2024-07-20",
    time: "10:00 AM",
    location: "123 Main St",
  },
  {
    id: 2,
    title: "Client Meeting: Project Alpha",
    date: "2024-07-22",
    time: "02:00 PM",
    location: "Virtual",
  },
  {
    id: 3,
    title: "Team Brainstorm: Q3 Strategy",
    date: "2024-07-25",
    time: "09:30 AM",
    location: "Office",
  },
]

export function UpcomingEventsWidget() {
  return (
    <Card elevation={2} sx={{ borderRadius: 2 }}>
      <CardContent>
        <Typography
          variant="h6"
          sx={{ color: "#0d2561", fontWeight: 600, mb: 2 }}
        >
          Upcoming Events
        </Typography>

        <Stack spacing={2}>
          {events.map((event) => (
            <Stack direction="row" spacing={2} alignItems="flex-start" key={event.id}>
              <CalendarDays size={20} style={{ color: "#0d2561", marginTop: 2 }} />
              <Box>
                <Typography variant="body2" fontWeight={500} color="#0d2561">
                  {event.title}
                </Typography>

                <Stack direction="row" spacing={1} alignItems="center" mt={0.5}>
                  <Clock size={14} style={{ color: "#6b7280" }} />
                  <Typography variant="caption" color="text.secondary">
                    {new Date(event.date).toLocaleDateString()} at {event.time}
                  </Typography>
                </Stack>

                <Stack direction="row" spacing={1} alignItems="center" mt={0.5}>
                  <MapPin size={14} style={{ color: "#6b7280" }} />
                  <Typography variant="caption" color="text.secondary">
                    {event.location}
                  </Typography>
                </Stack>
              </Box>
            </Stack>
          ))}
        </Stack>

        <Box mt={3} textAlign="right">
          <NavLink to="#" style={{ textDecoration: "none" }}>
            <Button
              variant="text"
              size="small"
              sx={{
                color: "#0d2561",
                p: 0,
                textTransform: "none",
                minHeight: "auto",
                fontSize: "0.875rem",
                fontWeight: 500,
              }}
              endIcon={<ArrowRight size={16} />}
            >
              View all events
            </Button>
          </NavLink>
        </Box>
      </CardContent>
    </Card>
  )
}
